var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","background-color":"#2d2b2b"}},[_c('v-card',{staticClass:"transparent",attrs:{"elevation":"0"}},[_c('v-card-text',{staticClass:"mx-auto m-txt-center",staticStyle:{"color":"#f6f6f6"}},[_vm._v(" Todos os Direitos Reservados à NetSpace | Desenvolvido por DELMAWAVE ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }